<div class="relative z-30" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  @if (isOpen()) {
    <div
      [@fadeIn]="isOpen()"
      class="fixed inset-0 bg-backdrop opacity-0"
      aria-hidden="true"
      data-testid="drawer-backdrop"
      (click)="close()"
    ></div>
    <div
      class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10 translate-x-full"
      [@slideRight]="isOpen()"
      (@slideRight.done)="contentAnimationDone()"
    >
      <div class="pointer-events-auto relative overflow-y-auto">
        <div class="flex flex-col w-full min-h-screen md:w-[490px] bg-white shadow-xl">
          <div class="grid px-4 md:px-6 sticky top-0 bg-white py-4 z-10">
            <button
              data-testid="close-button"
              type="button"
              (click)="close()"
              class="relative rounded-md text-gray-300 focus:outline-none focus:ring-2 focus:ring-white justify-self-end p-1 text-black hover:text-primary transition-all"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.4571 0.542893C15.8476 0.933417 15.8476 1.56658 15.4571 1.95711L1.95711 15.4571C1.56658 15.8476 0.933417 15.8476 0.542893 15.4571C0.152369 15.0666 0.152369 14.4334 0.542893 14.0429L14.0429 0.542893C14.4334 0.152369 15.0666 0.152369 15.4571 0.542893Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.542893 0.542893C0.933417 0.152369 1.56658 0.152369 1.95711 0.542893L15.4571 14.0429C15.8476 14.4334 15.8476 15.0666 15.4571 15.4571C15.0666 15.8476 14.4334 15.8476 14.0429 15.4571L0.542893 1.95711C0.152369 1.56658 0.152369 0.933417 0.542893 0.542893Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
          <div class="relative flex-1 px-4 md:px-6">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  }
</div>
